export default __webpack_public_path__ + "static/media/product-active.4a65423b.svg";